import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import "./DonutChart.css";

const DonutChartEvent = ({ eventData }) => {
  const [series, setSeries] = useState([]);
  const [labels, setLabels] = useState([]);
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "donut",
    },
    labels: [],
    legend: {
      show: false, // Disable the default legend to use custom labels below the chart
    },
    colors: [], // Dynamically populated
    dataLabels: {
      enabled: false, // Disable data labels on the donut
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: false, // Disable default labels in the center on hover
          },
        },
        expandOnClick: false, // Disable expand on click effect
        dataLabels: {
          minAngleToShowLabel: 1, // Allow smaller segments to display labels
        },
      },
    },
    tooltip: {
      enabled: true, // Enable tooltip
      theme: "light", // Set tooltip theme to light for black text
      style: {
        fontSize: "14px",
        fontWeight: "bold",
      },
    },
  });

  const generateColors = (numColors) => {
    const baseColors = [
      "#A8E308",
      "#00FFFF",
      "#FF1493",
      "#FF4500",
      "#FFD700",
      "#8A2BE2",
      "#6495ED",
    ];

    const additionalColors = [];
    const saturation = 50;
    const lightness = 95;

    for (let i = 0; i < numColors - baseColors.length; i++) {
      const hue = (i * 360) / (numColors - baseColors.length);
      additionalColors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    return [...baseColors, ...additionalColors].slice(0, numColors);
  };

  useEffect(() => {
    if (eventData && eventData.length > 0) {
      const labels = eventData.map((item) => item.eventType);
      const data = eventData.map((item) => item.eventCount);

      setLabels(labels);
      setSeries(data);

      setChartOptions((prevOptions) => ({
        ...prevOptions,
        labels: labels,
        colors: generateColors(labels.length),
      }));
    } else {
      setLabels([]);
      setSeries([]);
    }
  }, [eventData]);

  if (!eventData || eventData.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh", // Full viewport height to center vertically
          fontSize: "18px",
          color: "#666",
        }}
      >
        No data is available.
      </div>
    );
  }

  return (
    <div
      id="donut-chart"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <ReactApexChart
        options={chartOptions}
        series={series}
        type="donut"
        height={window.innerWidth <= 425 ? 200 : 360}
        width={window.innerWidth <= 425 ? 250 : 540}
      />

      {/* Custom legend below the chart */}
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {labels.map((label, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              margin: "5px 15px",
            }}
          >
            <span
              style={{
                width: "15px",
                height: "15px",
                backgroundColor: generateColors(labels.length)[index],
                marginRight: "8px",
                borderRadius: "3px",
              }}
            ></span>
            <span style={{ fontSize: "14px", color: "#333" }}>
              {label}: {((series[index] / series.reduce((a, b) => a + b, 0)) * 100).toFixed(1)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChartEvent;
